import styled from 'styled-components'
const Wrapper = styled.div`
  .sabhaSaar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}


.btn-blue-small {
    padding: 4px 20px;
    justify-content: center;
    gap: 1px;
    align-self: stretch;
    color: white;
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    border-radius: 10px;
    background: #0B3C5D;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}


.sabhaSaar-header-left, 
.sabhaSaar-header-right {
     display: flex;
    align-items: center;
    gap: 16px;
}
.sabhaSaar-header-left span, 
.sabhaSaar-header-right span {
  color: var(--bg-dark);
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  font-size: 1.125rem;
}

.sabhaSaar-header-left h4, 
.sabhaSaar-header-right h4 {
  color: #2C2C2C;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  font-size: 1.6rem;
  margin-bottom :0;
}

.sabhaSaar-header-right img {
  width: 3.8rem;
  height: 3.8rem;
}
.sabhaSaar-header-left img {
    width:10%;
}

@media (max-width: 768px) {
  .sabhaSaar-header {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    gap:0;
  }

  .sabhaSaar-header-left,
  .sabhaSaar-header-right {
    width: 100%;
    justify-content: flex-start;
  }
.sabhaSaar-header-left h4, 
.sabhaSaar-header-right h4 {
  color: #2C2C2C;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  font-size: 1rem;
}
  .sabhaSaar-header-left span,
  .sabhaSaar-header-right span {
    font-size: 0.8rem;
  }

  .sabhaSaar-header-left h4,
  .sabhaSaar-header-right h4 {
    font-size: 1.25rem;
  }

  .sabhaSaar-header-right {
    margin-top: 1rem;
  }
  .body-content{
        padding: 12px 20px;
        align-items: center;
  }
}


 `
  export default Wrapper